module.exports = __webpack_public_path__ + "fonts/Avalon-Bold.de78b17.woff2";